import Vue from 'vue'

const trPath = 'modules.budget_execution_monitoring.input_forms.massage_tools'

// статусы родительского свода, при которых дочерние формы недоступны: 26 — на согласовании УО, 31 — согласовано
export const PARENT_LOCKED_STATUSES = [26, 31]

export function isParentLocked(parent: any): boolean {
    return Boolean(parent) && PARENT_LOCKED_STATUSES.includes(parent?.status?.status)
}

// уровень родителя по коду региона: XX0000 — область, XX0101 — областной бюджет, XXYY00 — район
function parentLevelKey(region: string): string | null {
    if (region?.slice(2, 6) === '0000') return 'oblast'
    if (region?.slice(2, 6) === '0101') return 'obl_budget'
    if (region?.slice(4, 6) === '00') return 'district'
    return null
}

// название родительской формы; в kk «N-қосымша» → «N-қосымшасы» (притяжательная форма после уровня)
function parentFormName(vm: Vue, parent: any): string {
    const name: string = parent?.[`name_${vm.$i18n.locale}`] ?? parent?.form_code ?? ''
    return vm.$i18n.locale === 'kk' ? name.replace(/қосымша(сы)?/i, 'қосымшасы') : name
}

// текст ошибки validate_parent_error: {form} — название родительской формы, {level} — уровень родителя
export function parentErrorText(vm: Vue, parent: any): string {
    const levelKey = parentLevelKey(parent?.region)
    const text = vm.$t(`${trPath}.validate_parent_error`, {
        form: parentFormName(vm, parent),
        level: levelKey ? vm.$t(`${trPath}.parent_level.${levelKey}`) : ''
    }).toString().trim()
    return text.charAt(0).toUpperCase() + text.slice(1)
}
